import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensNikeFullZipSweatshirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[17].productName}
				color={product.allGear[17].color}
				size={product.allGear[17].sizes}
				price={product.allGear[17].price}
				img={product.allGear[17].img}
				miniImg1={product.allGear[17].miniImg1}
				miniImg2={product.allGear[17].miniImg2}
				miniImg3={product.allGear[17].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensNikeFullZipSweatshirt;
